import {AllCalculatorConditions, CalculatorCondition} from "../../../calculations/model/CalculatorCondition";
import './ConditionTypeFilter.scss';
import {ALL_CALCULATORS, CalculatorName} from "../../../calculations/model/Calculator";


interface CalculationCondtionUi extends CalculatorCondition {
    isActive: boolean;
}

interface ConditionTypeFilterScope extends ng.IScope {
    toggleCondition: (condition: CalculationCondtionUi) => void;
    allConditions: CalculationCondtionUi[];
}

export class ConditionTypeFilter implements ng.IController {
    private $scope: ConditionTypeFilterScope;
    private selectedConditions: CalculatorName[];

    static instance: ng.IComponentOptions = {
        template: require('./ConditionTypeFilter.html'),
        controller: ['$scope', ConditionTypeFilter],
        bindings: {
            "selectedConditions": '='
        }
    };

    constructor($scope: ConditionTypeFilterScope) {
        this.$scope = $scope;
        this.$scope.toggleCondition = this.toggleCondition;
        this.$scope.allConditions = AllCalculatorConditions.map((conditionType) => {
            let conditionUi = conditionType as CalculationCondtionUi;
            conditionUi.isActive = true;
            return conditionUi;
        });
    }

    $onInit(): void {
        this.selectedConditions = this.selectedConditions ? this.selectedConditions : ALL_CALCULATORS;
        this.$scope.allConditions
            .forEach(condition => condition.isActive = this.selectedConditions.includes(condition.value));
    }

    toggleCondition = (condition: CalculationCondtionUi): void => {
        condition.isActive = !condition.isActive;
        if (condition.isActive) {
            this.selectedConditions.push(condition.value);
        } else {
            let idx = this.selectedConditions.indexOf(condition.value);
            this.selectedConditions.splice(idx, 1);
        }
    };

}